import axios from 'axios'
import store from '@/store'
import router from '@/router'
import {toast} from "../class/Notification";
import {getBaseDomain, removeBlankAttributes} from "../class/Converter";
import {findObjectIndex} from "../class/Converter";
import {queryBuilder, filters} from '../class/QueryFilter'

let filtersCopy = JSON.parse(JSON.stringify(filters))

const reshapeForm = (form) => {
    const formData = new FormData();
    formData.append('name', form.name);
    formData.append('last_name', form.last_name);
    if (form.email != null && form.email != undefined && form.email.trim() !== '') formData.append('email', form.email);
    formData.append('cellphone', form.cellphone);

    if (form.password != null) {
        formData.append('password', form.password);
    }
    if (form.password_confirmation != null) {
        formData.append('password_confirmation', form.password_confirmation);
    }
    if (form.panels != null) {
        form.panels.forEach((item, index) => {
            formData.append(`panels[${index}]`, item);
        })
    }

    if (form.tags != undefined && form.tags.length > 0) {
        form.tags.forEach((item, index) => {
            formData.append(`tags[${index}]`, item.id);
        })
    }

    if (form.order_notification != null) {
        formData.append('order_notification', form.order_notification);
    }

    formData.append('role', form.role);
    formData.append('type', form.type);
    formData.append('public_name', form.public_name);
    if (form.description != null && form.description.trim() !== '') formData.append('description', form.description);
    if (form.meli_code != null && form.meli_code.trim() !== '') formData.append('meli_code', form.meli_code);
    if (form.image != null && (form.image.length > 0 || form.image.length == undefined)) formData.append('image', form.image);
    return formData
}


export const userAvatar = 'data:image/svg+xml;base64,PHN2ZyBkYXRhLXYtM2Y3NDVlOTY9IiIgdmlld0JveD0iMCAwIDE2IDE2IiB3aWR0aD0iMWVtIiBoZWlnaHQ9IjFlbSIgZm9jdXNhYmxlPSJmYWxzZSIgcm9sZT0iaW1nIiBhcmlhLWxhYmVsPSJwZXJzb24iIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmktcGVyc29uIGltZy1mbHVpZCBoMSBtbC1hdXRvIG1yLWF1dG8gcm91bmRlZCB0ZXh0LWNlbnRlciByb3VuZGVkLWNpcmNsZSBiLWljb24gYmkiPjxnIGRhdGEtdi0zZjc0NWU5Nj0iIj48cGF0aCBkPSJNOCA4YTMgMyAwIDEgMCAwLTYgMyAzIDAgMCAwIDAgNnptMi0zYTIgMiAwIDEgMS00IDAgMiAyIDAgMCAxIDQgMHptNCA4YzAgMS0xIDEtMSAxSDNzLTEgMC0xLTEgMS00IDYtNCA2IDMgNiA0em0tMS0uMDA0Yy0uMDAxLS4yNDYtLjE1NC0uOTg2LS44MzItMS42NjRDMTEuNTE2IDEwLjY4IDEwLjI4OSAxMCA4IDEwYy0yLjI5IDAtMy41MTYuNjgtNC4xNjggMS4zMzItLjY3OC42NzgtLjgzIDEuNDE4LS44MzIgMS42NjRoMTB6Ij48L3BhdGg+PC9nPjwvc3ZnPg=='

export const rolesTranslate = {
    '1-0': 'مدیر',
    '0-0': 'کاربر',
    '2-1': 'فروشگاه',
    '1-1': 'ویرایشگر', // 3
    '1-2': 'نویسنده', // 4
    '1-3': 'مدیریت سفارشات', // 5
}

export default {
    namespaced: true,
    state: {
        persons: [],
        trash: [],
        person: {},
        links: {},
        meta: {},
        profile: {},
        token: null,
        ...filtersCopy,
    },
    mutations: {
        setPersons(state, persons) {
            state.persons = persons;
        },
        setTrash(state, trash) {
            state.trash = trash;
        },
        setPerson(state, person) {
            state.person = person;
            state.person.password = '';
            state.person.password_confirmation = '';
            state.person.current_password = '';

            // set profile if we set person was current profile
            if (person.id == state.profile.id) {
                state.profile = person
            }

        },
        setLinks(state, links) {
            state.links = links;
        },
        setMeta(state, meta) {
            state.meta = meta;
        },
        removePerson: (state, person) => {
            state.persons.splice(findObjectIndex(state.persons, person), 1)
            state.trash.splice(findObjectIndex(state.trash, person), 1)
        },
        setUser(state, user) {
            state.profile = user;
        },
        setToken(state, token) {
            state.token = token;
        },
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
    },
    actions: {
        getPersons({state, commit}, page = 1) {
            const query = queryBuilder(state.filters)
            axios.get(`user?page=${page}&${query}`)
                .then(res => {
                    res = res.data.data;
                    commit('setPersons', res.data);
                    commit("setLinks", res.links);
                    commit("setMeta", res.meta);
                })
                .catch(error => {
                    toast.error(error.response.data.message);
                    console.log(error)
                })
        },
        getPersonsWithoutState({state, commit}, page = 1) {
            const query = queryBuilder(state.filters)
            return axios.get(`user?page=${page}&${query}`)
        },
        getTrash({commit}, page = 1) {
            axios.post(`user/trash?page=${page}`)
                .then(res => {
                    res = res.data.data;
                    commit('setTrash', res.data);
                    commit('setMeta', res.meta);
                })
                .catch(error => {
                    toast.error(error.response.data.message);
                    console.log(error)
                })
        },
        getPerson({commit}, id) {
            let req = axios.get(`user/${id}`);

            req.then(res => {
                res = res.data.data
                commit('setPerson', res);
                return res.data;
            })
                .catch(error => {
                    router.push({name: 'NotFound'})
                })
            return req
        },
        deletePerson({commit}, person) {
            axios.delete(`user/${person.id}`)
                .then(res => {
                    const deleted = res.data.data;

                    toast('کاربر با موفقیت حذف شد ', 'کاربر با موفقیت حذف شد ')
                    commit('removePerson', person)
                })
                .catch(error => {
                    toast(error.response.data.message);
                    console.log(error)
                });
        },
        forceDeletePerson({commit}, person) {
            axios.delete(`user/${person.id}/force-delete`)
                .then(res => {
                    const deleted = res.data.data;

                    toast('کاربر با موفقیت حذف شد ', 'کاربر با موفقیت حذف شد ')
                    commit('removePerson', person)
                })
                .catch(error => {
                    toast(error.response.data.message);
                    console.log(error)
                });
        },
        restorePerson({commit}, person) {
            axios.put(`user/${person.id}/restore`)
                .then(res => {
                    const deleted = res.data.data;

                    commit('removePerson', person)
                    toast('کاربر با موفقیت بازیابی شد ', 'کاربر با موفقیت بازیابی شد ')
                })
                .catch(error => {
                    toast(error.response.data.message);
                    console.log(error)
                });
        },
        updatePerson({commit}, form) {
            let formData = removeBlankAttributes(form);
            formData = reshapeForm(formData)
            formData.append('_method', 'PUT');
            let req = axios.post(`/user/${form.id}`, formData);

            req.then(res => {
                const person = res.data.data.user;

                toast('عملیات با موفقیت انجام شد', 'به روز رسانی با موفقیت انجام شد')
                commit('setPerson', person)
            })
                .catch(error => {
                    toast.error(error.response.data.message);
                    console.log(error)
                });
            return req
        },
        createPerson({commit}, form) {
            let formData = removeBlankAttributes(form);
            formData = reshapeForm(formData)
            axios.post(`/user/create`, formData)
                .then(res => {
                    const person = res.data.data.user;
                    toast('عملیات با موفقیت انجام شد', 'ساخت کاربر جدید با موفقیت انجام شد')
                    router.push({name: 'UpdateUser', params: {id: person.id}})
                    commit('setPerson', person)

                })
                .catch(error => {
                    console.log(error)
                });
        },
        setUserState({commit}, res) {
            const token = res.data.data.token
            const profile = res.data.data.user;
            localStorage.setItem('token', token)

            /* set cookies */
            let domain = getBaseDomain(false).split('.').slice(-2).join('.');
            document.cookie = 'token' + "=" + token + `;path=/;expires=${(new Date(Date.now() + 86400 * 500000)).toUTCString()};domain=.` + domain;

            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
            commit('setUser', profile)
            commit('setToken', token)
        },
        setToken({commit}, token) {
            commit('setToken', token)
        },
        setProfile({commit}, profile) {
            commit('setUser', profile)
        },
        editProfile({commit}, form) {
            const userId = store.getters['User/getUserId'];
            form = removeBlankAttributes(form)
            form = reshapeForm(form)
            form.append('_method', 'PUT');
            axios.post(`/user/${userId}`, form).then(res => {
                const profile = res.data.data.user;
                toast('عملیات با موفقیت انجام شد', 'به روز رسانی با موفقیت انجام شد')
                commit('setUser', profile)
            }).catch(error => {
                console.log(error)
            })
        },
        searchUsers({commit}, {form, page = 1}) {
            axios.post(`/user/search?page=${page}`, form)
                .then(response => {
                    const data = response.data
                    commit('setPersons', data.data.data);
                    commit('setLinks', data.data.links);
                    commit('setMeta', data.data.meta);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getUserWithoutState({state, commit}, form) {
            return axios.get(`user/${form.user_id}`)
        },
        removeUserPanel({commit}, form) {
            let req = axios.post(`/user/${form.user_id}/remove-panels`);
            req.then(res => {
                const person = res.data.data;

                toast('عملیات با موفقیت انجام شد', 'به روز رسانی با موفقیت انجام شد')
                commit('setPerson', person)
            })
                .catch(error => {
                    toast.error(error.response.data.message);
                    console.log(error)
                });
            return req
        },
        storeUserCoordinate({commit}, form) {
            let req = axios.post(`/user/store-coordinate`, form);
            return req
        },
        exportUsers({commit, state}) {
            const query = queryBuilder(state.filters)
            let req = axios.get(`/export/users?${query}`);
            return req
        },
    },
    getters: {
        getPersons: state => state.persons,
        getTrash: state => state.trash,
        getPerson: (state) => state.person,
        getPaginationLinks: (state) => state.links,
        getPaginationMeta: (state) => state.meta,

        getToken: state => state.token,
        getProfile: state => state.profile,
        getUserId: state => state.profile.id,
        getUserCellphone: state => state.profile.cellphone,
        getUserEmail: state => state.profile.email,
        isPhoneVerified: state => state.profile.cellphone_verified_at !== null,
        isEmailVerified: state => state.profile.email_verified_at !== null,
        isAuthenticated: state => state.token !== null,
        isAdmin: (state) => {
            if (state.profile == undefined) {
                return false
            }
            return state.profile.role == 1
        },
        isUserStore: (state) => {
            if (state.profile == undefined) {
                return false
            }
            return state.profile.role == 2 && state.profile.type == 1
        },
    }
}